export default function() {
  let max = 0;
  const elements = document.querySelectorAll('.match-height');

  [].reduce.call(elements, function(prev, item) {
    max = Math.max(item.clientHeight, max);

   return function(height) {
     prev(item.parentNode.style.height = height);
   };
  }, function() {})(max + 'px');
}
